import { render, staticRenderFns } from "./organization-form.vue?vue&type=template&id=395b6d39"
import script from "./organization-form.vue?vue&type=script&lang=js"
export * from "./organization-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports